module.exports = __webpack_public_path__ + "static/media/s10.73a15ef2.png";